<script setup>
import webShoppingImage from '@images/illustrations/web-shopping.svg';
import { computed, ref } from 'vue';
import { useStore } from '@/store';
import { useRoute, useRouter } from 'vue-router';

import axios from '@/axios';
import { useToast } from '@/plugins/toast';

import SellerProfileForm from '@/components/Secondary/Marketplace/SellerProfileForm.vue';
import SideNav from '@/views/marketplace/_helpers/layout/SideNav.vue';

const landingBtnLoading = ref(false);
const store = useStore();
const router = useRouter();
const route = useRoute();
const toast = useToast();

const activeStep = computed(() => {
    return route.query.step ?? 'landing';
});

const setUpSellerProfile = () => {
    landingBtnLoading.value = true;

    axios.get(`/api/marketplace/sellers/${store.state.user.id}`)
        .then(() => router.push({ name: 'marketplace.sellers.show', params:  { id: store.state.user.id } }))
        .catch((error) => {
            if (error.response && error.response.status === 404) {
                router.push({
                    query: {
                        step: 'form',
                    }
                });

                return;
            }

            toast.error('An error occured, please try again.');

            console.error(error);
        }).finally(() => landingBtnLoading.value = false);
}
</script>

<template>
    <layout-main>
        <head-title value="Create Marketplace Profile" />
        <SideNav />
        <layout-content>
            <content-header hide-border>
                <top-nav>
                    <top-nav-back hide-from-desktop />

                    <top-nav-title v-if="activeStep === 'form'">Setup Seller Profile</top-nav-title>
                </top-nav>
            </content-header>
            <content-body>
                <div v-if="activeStep === 'landing'" class="px-4">
                    <div class="w-full max-w-80 mx-auto mt-16 mb-10">
                        <img :src="webShoppingImage" />
                    </div>
                    <div class="text-3xl md:text-4xl font-bold text-center mb-2">
                        Start Selling on Corperland
                    </div>
                    <div class="text-base md:text-lg text-center text-muted leading-relaxed max-w-md mx-auto mb-6">
                        Whether you're selling one item or running a full shop, your hustle belongs here.
                        Create your seller profile, list your products, and grow with buyers who trust verified sellers.
                    </div>

                    <app-button @click="setUpSellerProfile" class="mx-auto" type="button" color="primary" capitalize :loading="landingBtnLoading">
                        Setup my seller profile
                    </app-button>
                </div>
                <div class="px-4 py-4" v-else-if="activeStep === 'form'">
                    <SellerProfileForm />
                </div>
            </content-body>
        </layout-content>
    </layout-main>
</template>
